export default __webpack_public_path__ + "89917f5b5ea26d58837318465ad635a4.png";